import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  title: 'ONE TIME PAYMENT',
  list: [{
    leftDetails: {
      text: 'postpaid plan',
      title: 'postpaid plan'
    },
    showInfoIcon: true,
    toolTipProps: {
      text: 'description goes here'
    },
    rightDetails: {
      text: 'FREE',
      title: 'FREE',
      status: 'success',
      strikedText: '₹1400',
      strikedTextColor: 'grey'
    }
  }, {
    leftDetails: {
      text: 'taxes - GST'
    },
    rightDetails: {
      text: '₹24.00'
    }
  }, {
    leftDetails: {
      text: 'discount'
    },
    rightDetails: {
      text: '-₹25.00',
      status: 'success'
    }
  }, {
    leftDetails: {
      text: 'more taxes'
    },
    rightDetails: {
      text: '₹0',
      status: 'error'
    },
    showInfoTag: true,
    infoTagProps: {
      text: 'info tag...',
      iconName: 'InfoIcon'
    },
    subtext: 'some subtext',
    showDivider: true
  }, {
    leftDetails: {
      text: 'total amount'
    },
    rightDetails: {
      text: '₹599.00',
      isBold: true
    },
    showInfoTag: true,
    infoTagProps: {
      text: 'info tag...',
      iconName: 'InfoIcon'
    },
    subtext: 'some subtext'
  }]
}, getTestId('PriceBreakupWidgetContainer'));